module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-setting"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "bg-white min-height"
  }, [_c('home-sidebar', {
    attrs: {
      "active_item": "users"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "bg-white min-height ml-3 pt-3"
  }, [_c('el-form', {
    staticClass: "search-form",
    attrs: {
      "label-width": "90px",
      "label-position": "right"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "搜索条件"
    }
  }, [_c('el-input', {
    staticClass: "input-with-select",
    attrs: {
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.form.query),
      callback: function($$v) {
        _vm.$set(_vm.form, "query", $$v)
      },
      expression: "form.query"
    }
  }, [_c('el-select', {
    staticClass: "mobile-hidden",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "slot": "prepend",
      "placeholder": "请选择"
    },
    slot: "prepend",
    model: {
      value: (_vm.form.query_field),
      callback: function($$v) {
        _vm.$set(_vm.form, "query_field", $$v)
      },
      expression: "form.query_field"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Email",
      "value": "email"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "用户名",
      "value": "name"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "真实名",
      "value": "realName"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "手机号",
      "value": "phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "ml-2",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getUsers
    }
  }, [_vm._v("查看结果")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.btn_cancel
    }
  }, [_vm._v("重置选项")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角色"
    }
  }, [_c('el-select', {
    staticClass: "item_w",
    attrs: {
      "placeholder": "请选择角色",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.role_change($event, 'birth')
      }
    },
    model: {
      value: (_vm.form.role),
      callback: function($$v) {
        _vm.$set(_vm.form, "role", $$v)
      },
      expression: "form.role"
    }
  }, _vm._l((_vm.roles), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('label', {
    staticClass: "item_label"
  }, [_vm._v("用户组")]), _vm._v(" "), _c('el-select', {
    staticClass: "item_w",
    attrs: {
      "placeholder": "请选择用户组",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.groupChange($event, 'birth')
      }
    },
    model: {
      value: (_vm.form.groupId),
      callback: function($$v) {
        _vm.$set(_vm.form, "groupId", $$v)
      },
      expression: "form.groupId"
    }
  }, _vm._l((_vm.groups), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "",
      "icon": "el-icon-edit"
    },
    on: {
      "click": _vm.add_group
    }
  }, [_vm._v("添加组")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.add_user
    }
  }, [_vm._v("添加用户")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "",
      "icon": "el-icon-delete"
    },
    on: {
      "click": _vm.batchRemove
    }
  }, [_vm._v("删除用户")])], 1)], 1)], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total, prev, pager, next",
      "page-size": _vm.page.size,
      "current-page": _vm.page.index + 1,
      "total": _vm.page.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "stripe": "",
      "data": _vm.users,
      "border": "",
      "highlight-current": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "用户名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realName",
      "label": "真实名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "Email"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inviteBy",
      "label": "推荐人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lastLogin",
      "label": "最近登录时间",
      "width": "155px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm._f("formatDateTime")(scope.row.lastLogin)) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deadline",
      "label": "账户过期",
      "width": "155px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm._f("formatDateTime")(scope.row.deadline)) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "active",
      "label": "禁用",
      "width": "60px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.active == '1') ? _c('el-button', {
          attrs: {
            "circle": "",
            "type": "info"
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.active == null || scope.row.active == 0) ? _c('el-button', {
          attrs: {
            "circle": "",
            "type": "primary"
          }
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "角色"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.roles), function(role) {
          return _c('div', [_vm._v("\n                  " + _vm._s(role) + "\n                ")])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-dropdown', {
          attrs: {
            "trigger": "click"
          },
          on: {
            "command": _vm.update_scale
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_vm._v("\n                            操作"), _c('i', {
          staticClass: "el-icon-arrow-down el-icon--right"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          attrs: {
            "command": _vm.before_update_scale('resetPwd', scope.row)
          }
        }, [_vm._v("重置密码\n                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": _vm.before_update_scale('edit', scope.row)
          }
        }, [_vm._v("编辑用户\n                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": _vm.before_update_scale('userAction', scope.row)
          }
        }, [_vm._v("查看用户操作\n                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": _vm.before_update_scale('charge', scope.row)
          }
        }, [_vm._v("给用户充值\n                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": _vm.before_update_scale('activeUser', scope.row)
          }
        }, [_vm._v("启用/停用\n                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": _vm.before_update_scale('requireLogin', scope.row)
          }
        }, [_vm._v("踢出\n                    ")])], 1)], 1)]
      }
    }])
  })], 1)], 1)])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.formTitle,
      "visible": _vm.dlg_add_user,
      "close-on-click-modal": false,
      "width": "800px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dlg_add_user = $event
      }
    }
  }, [_c('el-form', {
    ref: "userForm",
    attrs: {
      "model": _vm.userForm,
      "rules": _vm.rules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "登录名",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "item_form",
    model: {
      value: (_vm.userForm.name),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "name", $$v)
      },
      expression: "userForm.name"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "item_label"
  }, [_vm._v("余额")]), _vm._v(" "), _c('el-input', {
    staticClass: "item_form",
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.userForm.remain),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "remain", $$v)
      },
      expression: "userForm.remain"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "id"
    }
  }, [_c('el-input', {
    staticClass: "item_form",
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.userForm.id),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "id", $$v)
      },
      expression: "userForm.id"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "item_label"
  }, [_vm._v("groupId")]), _vm._v(" "), _c('el-input', {
    staticClass: "item_form",
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.userForm.groupId),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "groupId", $$v)
      },
      expression: "userForm.groupId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话"
    }
  }, [_c('el-input', {
    staticClass: "item_form",
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.userForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "phone", $$v)
      },
      expression: "userForm.phone"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "item_label"
  }, [_vm._v("邮箱")]), _vm._v(" "), _c('el-input', {
    staticClass: "item_form",
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.userForm.email),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "email", $$v)
      },
      expression: "userForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邀请码"
    }
  }, [_c('el-input', {
    staticClass: "item_form",
    attrs: {
      "auto-complete": "off",
      "aria-placeholder": "具备邀请资格"
    },
    model: {
      value: (_vm.userForm.invite),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "invite", $$v)
      },
      expression: "userForm.invite"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属团队",
      "prop": "groupId"
    }
  }, [_c('el-select', {
    staticClass: "item_form",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.userForm.groupId),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "groupId", $$v)
      },
      expression: "userForm.groupId"
    }
  }, _vm._l((_vm.groups), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('label', {
    staticClass: "item_label"
  }, [_vm._v("角色")]), _vm._v(" "), _c('el-select', {
    staticClass: "item_form",
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.userForm.roles),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "roles", $$v)
      },
      expression: "userForm.roles"
    }
  }, _vm._l((_vm.roles), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "真实姓名"
    }
  }, [_c('el-input', {
    staticClass: "item_form",
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.userForm.realName),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "realName", $$v)
      },
      expression: "userForm.realName"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "item_label"
  }, [_vm._v("身份证号")]), _vm._v(" "), _c('el-input', {
    staticClass: "item_form",
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.userForm.idCard),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "idCard", $$v)
      },
      expression: "userForm.idCard"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出生日期"
    }
  }, [_c('el-date-picker', {
    staticClass: "item_form",
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.userForm.birthDay),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "birthDay", $$v)
      },
      expression: "userForm.birthDay"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "item_label"
  }, [_vm._v("性别")]), _vm._v(" "), _c('el-radio-group', {
    staticClass: "item_form",
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.userForm.gender),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "gender", $$v)
      },
      expression: "userForm.gender"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "male"
    }
  }, [_vm._v("男性")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "female"
    }
  }, [_vm._v("女性")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出生地区"
    }
  }, [_c('el-select', {
    staticClass: "item_form",
    attrs: {
      "placeholder": "请选择省份",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getProv($event)
      }
    },
    model: {
      value: (_vm.userForm.birthProv),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "birthProv", $$v)
      },
      expression: "userForm.birthProv"
    }
  }, _vm._l((_vm.provs), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('label', {
    staticClass: "item_label"
  }, [_vm._v("出生城市")]), _vm._v(" "), _c('el-select', {
    staticClass: "item_form",
    attrs: {
      "placeholder": "请选择城市",
      "clearable": ""
    },
    model: {
      value: (_vm.userForm.birthCity),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "birthCity", $$v)
      },
      expression: "userForm.birthCity"
    }
  }, _vm._l((_vm.citys), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "毕业学校"
    }
  }, [_c('el-input', {
    staticClass: "item_form",
    model: {
      value: (_vm.userForm.school),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "school", $$v)
      },
      expression: "userForm.school"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "item_label"
  }, [_vm._v("学历")]), _vm._v(" "), _c('el-input', {
    staticClass: "item_form",
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.userForm.degree),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "degree", $$v)
      },
      expression: "userForm.degree"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "居住地"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "480px"
    },
    model: {
      value: (_vm.userForm.address),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "address", $$v)
      },
      expression: "userForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人"
    }
  }, [_c('el-input', {
    staticClass: "item_form",
    model: {
      value: (_vm.userForm.friend),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "friend", $$v)
      },
      expression: "userForm.friend"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "item_label"
  }, [_vm._v("联系人电话")]), _vm._v(" "), _c('el-input', {
    staticClass: "item_form",
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.userForm.friendPhone),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "friendPhone", $$v)
      },
      expression: "userForm.friendPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "608px"
    },
    attrs: {
      "type": "textarea",
      "rows": 6
    },
    model: {
      value: (_vm.userForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "remark", $$v)
      },
      expression: "userForm.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.btn_add_user
    }
  }, [_vm._v("立即添加")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dlg_add_user = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加团队",
      "visible": _vm.dlg_add_group,
      "close-on-click-modal": false,
      "width": "750px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dlg_add_group = $event
      }
    }
  }, [_c('el-form', {
    ref: "groupForm",
    attrs: {
      "label-width": "100px",
      "rules": _vm.rules,
      "model": _vm.groupForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.groupForm.name),
      callback: function($$v) {
        _vm.$set(_vm.groupForm, "name", $$v)
      },
      expression: "groupForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "全称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "500px"
    },
    model: {
      value: (_vm.groupForm.fullName),
      callback: function($$v) {
        _vm.$set(_vm.groupForm, "fullName", $$v)
      },
      expression: "groupForm.fullName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "团队ID"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.groupForm.id),
      callback: function($$v) {
        _vm.$set(_vm.groupForm, "id", $$v)
      },
      expression: "groupForm.id"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "93px",
      "padding-left": "20px"
    }
  }, [_vm._v("管理员ID")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.groupForm.adminId),
      callback: function($$v) {
        _vm.$set(_vm.groupForm, "adminId", $$v)
      },
      expression: "groupForm.adminId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "appid"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.groupForm.appid),
      callback: function($$v) {
        _vm.$set(_vm.groupForm, "appid", $$v)
      },
      expression: "groupForm.appid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "secret"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.groupForm.secret),
      callback: function($$v) {
        _vm.$set(_vm.groupForm, "secret", $$v)
      },
      expression: "groupForm.secret"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "模块"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.groupForm.moduleList),
      callback: function($$v) {
        _vm.$set(_vm.groupForm, "moduleList", $$v)
      },
      expression: "groupForm.moduleList"
    }
  }, _vm._l((_vm.modules), function(item) {
    return _c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v("\n            " + _vm._s(item.label) + "\n          ")])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "省份"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择省份"
    },
    on: {
      "change": function($event) {
        return _vm.getProv($event)
      }
    },
    model: {
      value: (_vm.groupForm.province),
      callback: function($$v) {
        _vm.$set(_vm.groupForm, "province", $$v)
      },
      expression: "groupForm.province"
    }
  }, _vm._l((_vm.provs), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "80px",
      "padding-left": "40px"
    }
  }, [_vm._v("城市")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择城市"
    },
    on: {
      "click": function($event) {
        return _vm.alert()
      },
      "change": function($event) {
        return _vm.getCity($event)
      }
    },
    model: {
      value: (_vm.groupForm.city),
      callback: function($$v) {
        _vm.$set(_vm.groupForm, "city", $$v)
      },
      expression: "groupForm.city"
    }
  }, _vm._l((_vm.citys), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "500px"
    },
    model: {
      value: (_vm.groupForm.address),
      callback: function($$v) {
        _vm.$set(_vm.groupForm, "address", $$v)
      },
      expression: "groupForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮编"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.groupForm.post_code),
      callback: function($$v) {
        _vm.$set(_vm.groupForm, "post_code", $$v)
      },
      expression: "groupForm.post_code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人",
      "prop": "contact"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.groupForm.contact),
      callback: function($$v) {
        _vm.$set(_vm.groupForm, "contact", $$v)
      },
      expression: "groupForm.contact"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人邮箱"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.groupForm.email),
      callback: function($$v) {
        _vm.$set(_vm.groupForm, "email", $$v)
      },
      expression: "groupForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人电话"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.groupForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.groupForm, "phone", $$v)
      },
      expression: "groupForm.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "loading": _vm.addLoading,
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clk_add_group.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.dlg_add_group = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "用户操作记录",
      "visible": _vm.dlg_userAction,
      "close-on-click-modal": false,
      "width": "750px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dlg_userAction = $event
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "充值",
      "visible": _vm.dlg_charge,
      "close-on-click-modal": false,
      "width": "450px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dlg_charge = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "remain"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.balance.remain),
      callback: function($$v) {
        _vm.$set(_vm.balance, "remain", $$v)
      },
      expression: "balance.remain"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "total"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.balance.total),
      callback: function($$v) {
        _vm.$set(_vm.balance, "total", $$v)
      },
      expression: "balance.total"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "trial"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.balance.trial),
      callback: function($$v) {
        _vm.$set(_vm.balance, "trial", $$v)
      },
      expression: "balance.trial"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "trialTotal"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.balance.trialTotal),
      callback: function($$v) {
        _vm.$set(_vm.balance, "trialTotal", $$v)
      },
      expression: "balance.trialTotal"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "userName"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.balance.userName),
      callback: function($$v) {
        _vm.$set(_vm.balance, "userName", $$v)
      },
      expression: "balance.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "添加"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.balance.addition),
      callback: function($$v) {
        _vm.$set(_vm.balance, "addition", $$v)
      },
      expression: "balance.addition"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "loading": _vm.addLoading,
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clk_charge.apply(null, arguments)
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.dlg_charge = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d79dac4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/sys/Users.vue
// module id = 286
// module chunks = 1